import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { jsx } from 'react/jsx-runtime';

const CurrentVariantStateContext = createContext({
    setVariant: () => { },
    setVariantList: () => [],
    setInitialSku: () => { },
    currentVariant: {
        variantId: '',
        barcodeNumber: '',
        title: '',
        variantSku: '',
        imageIndex: '',
    },
});
const useCurrentVariantStateContext = () => useContext(CurrentVariantStateContext);

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

const getLocationPath = () => isBrowser() ? window.location.pathname : null;
const getLocationQueryStringParam = (param, strategy = 'array') => {
    if (!isBrowser()) {
        return strategy === 'string' ? '' : [];
    }
    const qs = new URLSearchParams(window.location.search);
    const stringValue = decodeURIComponent(qs.get(param) || '');
    if (strategy === 'string') {
        return stringValue;
    }
    try {
        return JSON.parse(`[${stringValue}]`);
    }
    catch (e) {
        console.error(e);
        return [];
    }
};
const generateLocationQueryString = (param, value) => {
    if (!isBrowser()) {
        return '';
    }
    const qs = new URLSearchParams(window.location.search);
    qs.set(param, value);
    return `${getLocationPath()}?${qs.toString()}`;
};

const CurrentVariantStateProvider = ({ children }) => {
    const [variantId, setVariantId] = useState('');
    const [initialSku, setInitialSku] = useState('');
    const [variantList, setVariantList] = useState([]);
    const [currentVariant, setCurrentVariant] = useState({});
    const setVariant = (id) => {
        setVariantId(id);
        const url = generateLocationQueryString('variantId', id);
        window.history.pushState(null, '', url);
    };
    const idFromQuery = getLocationQueryStringParam('variantId', 'string');
    useEffect(() => {
        const initialVariant = variantList.find((v) => v.variantSku === initialSku);
        if (!idFromQuery && initialVariant) {
            setVariant(initialVariant.variantId);
        }
    }, [initialSku]);
    useEffect(() => {
        if (idFromQuery) {
            setVariantId(idFromQuery);
        }
    }, [idFromQuery]);
    useEffect(() => {
        const searchedVariant = variantList.find((v) => v.variantId === variantId);
        if (searchedVariant) {
            setCurrentVariant(searchedVariant);
        }
    }, [variantId, variantList]);
    const currentVariantState = useMemo(() => ({
        currentVariant,
        setInitialSku,
        setVariant,
        setVariantList,
    }), [currentVariant]);
    return (jsx(CurrentVariantStateContext.Provider, Object.assign({ value: currentVariantState }, { children: children })));
};

export { CurrentVariantStateContext, CurrentVariantStateProvider, useCurrentVariantStateContext };
